// Environment configuration
// Auto-detect BASE_URL from window.location.origin to make it work on any domain
// Works with any domain: carousello.gr, digitalicdj.com, bartistaproject.com, ktsaousis.com, dorofrenia.gr, etc.
export const BASE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://carousello.gr'

// Auto-generated URLs based on BASE_URL
export const API_BASE_URL = `${BASE_URL}/backend/api`
export const IMAGE_BASE_URL = `${BASE_URL}/backend/api/image.php`
export const UPLOADS_BASE_URL = `${BASE_URL}/backend/uploads`

// Helper functions for different upload types
export const getGalleryImageUrl = (filename: string) => `${BASE_URL}/backend/uploads/gallery/${filename}`
export const getLogoUrl = (filename: string) => `${BASE_URL}/backend/uploads/logos/${filename}?v=${Date.now()}`
export const getAssetUrl = (filename: string) => `${BASE_URL}/backend/uploads/assets/${filename}`
export const getImageUrl = (imagePath: string) => `${BASE_URL}/backend/uploads${imagePath.startsWith('/') ? '' : '/'}${imagePath}`
